import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Colors, CommonFonts } from '@/theme';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      boxShadow: 'none',
      '&:before': {
        backgroundColor: 'transparent'
      }
    },
    menuWrapper: {
      padding: theme.spacing(3),
    },
    workBoardWrapper: {
      marginLeft: theme.spacing(4),
    },
    workBoard: {
      color: Colors.DIM_GREY,
      fontSize: 20,
      letterSpacing: 0,
      lineHeight: '15px',
    },
    drawerContent: {
      width: 435,
    },
    backWrapper: {
      padding: theme.spacing(6, 6, 10, 6),
    },
    menuList: {
      padding: theme.spacing(0, 6, 8, 6),
    },
    list: {
      padding: 0,
      paddingTop: theme.spacing(2),
      width: '100%',
    },
    nameMenuList: {
      marginBottom: theme.spacing(5),
      ...CommonFonts.darkFont20,
      letterSpacing: '-0.35px',
      fontWeight: 600,
    },
    menuItem: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(3),
      '&:hover': {
        backgroundColor: Colors.GRAY_BORDER1_25,
      },
    },
    menuBigItem: {
      height: 80,
      padding: theme.spacing(3),
      marginBottom: theme.spacing(4),
    },
    menuSmallItem: {
      height: 60,
      padding: theme.spacing(2.5),
      marginBottom: theme.spacing(2),
    },
    iconBigWrapper: {
      display: 'flex',
      paddingRight: theme.spacing(6),
    },
    iconSmallWrapper: {
      display: 'flex',
      paddingRight: theme.spacing(3),
    },
    nameMenuItem: {
      ...CommonFonts.darkFont24,
      fontWeight: 300,
      letterSpacing: 0.15,
      lineHeight: '20px',
    },
    nameMenuSmallItem: {
      ...CommonFonts.darkFont18,
      fontWeight: 300,
      letterSpacing: 0.56,
      lineHeight: '24px',
    },
    boxAccordionTitle: {
      display: 'flex',
      alignItems: 'center',
    },
    summary: {
      marginBottom: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      '&:hover': {
        backgroundColor: 'rgba(186, 195, 201, 0.25)',
      },
    },
    summaryContent: {
      width: '100%',
    },
    summaryText: {
      ...CommonFonts.darkFont16,
      fontWeight: 500,
    },
    descriptionText: {
      ...CommonFonts.grayFont16,
      color: '#505C69',
    },
    actionText: {
      ...CommonFonts.darkFont16,
      color: '#1174F2',
      cursor: 'pointer',
    },
    boxText: {
      marginTop: 0,
      [theme.breakpoints.down('sm')]: {
        marginTop: -theme.spacing(5),
        marginBottom: theme.spacing(8),
      },
    },
    details: {
      paddingLeft: theme.spacing(12),
      paddingRight: theme.spacing(10),
      [theme.breakpoints.down('sm')]: {
        paddingLeft: theme.spacing(8),
        paddingRight: theme.spacing(8),
      },
    },
  })
);

export default useStyles;
